import { Molecule } from 'AppReact';
import styled from 'styled-components';
import { Title } from './atoms';
import { ProgressBar } from 'atoms';

const template = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  margin-top: 16px;

  @media only screen and (min-width: 768px) {
    margin-top: 0px;
    width: 235px;
  }
`;

export default Molecule({
  template,
  atoms: [
    {
      component: ProgressBar,
      name: 'ProgressBar',
      displayValue: ({ }) => '',
      displayState: ({ skill }) => ({ progress: (skill.children.filter(child => child.active).length / skill.children.length) * 100 }),
    },
    {
      component: Title,
      name: 'Title',
      displayValue: ({ skill }) => `${skill.children.filter(child => child.active).length} / ${skill.children.length}`,
    },
  ],
})